import script from "./WorkflowDesigner.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowDesigner.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowDesigner.vue?vue&type=style&index=0&id=6d660b48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d660b48"]])

export default __exports__